export class ServiceItemOperationCriteria {
    operation: ServiceItemOperation;
}


export enum ServiceItemOperation{
    MERGE = 'merge'
}
